import React from 'react'
import { useTheme } from '../../../app/hooks/useTheme'

const ThemeToggle = () => {
    const { mode, toggleMode } = useTheme()

    return (
        <div
            onClick={toggleMode}
            title={mode === 'light' ? 'Dark moda geç' : 'Light moda geç'}
            style={{ cursor: 'pointer', fontSize: '1.2rem', lineHeight: 1 }}
        >
            {mode === 'light' ? '🌙' : '☀️'}
        </div>
    )
}

export default ThemeToggle